var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { directives: [{ name: "show", rawName: "v-show", value: _vm.isDev, expression: "isDev" }], ref: "xielunyan", staticClass: "xielunyan" }, [_c('div', { staticClass: "moveIcon", on: { "mousedown": function mousedown($event) {
        $event.stopPropagation();return _vm.mousedown.apply(null, arguments);
      } } }, [_c('svg-icon', { attrs: { "size": 26, "icon-class": "move" } })], 1), _vm._v(" "), _vm.isXieLunYan ? _c('el-tooltip', { attrs: { "trigger": "hover", "content": _vm.xielunyanStatus ? '关闭写轮眼' : '打开写轮眼' } }, [_c('div', { staticClass: "to-ss", on: { "click": function click($event) {
        return _vm.handleXieLunYan($event);
      } } }, [_c('pt-icon', { attrs: { "size": 20, "color": "#999" } }, [!_vm.xielunyanStatus ? _c('ic-visible') : _c('ic-hidden')], 1)], 1)]) : _vm._e()], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };